import { RequestMethod } from '~/shared/constants/commonConstants'
import { getCurrentEnv } from '~/shared/helpers/getCurrentEnv'
import { ApiService } from '~/shared/services/api'
import { Events } from '~/shared/services/eventLogger'

const btoaAuthCredentialsProd =
  'cHJvZC1mYWNlLXlvZ2Etd3Nob29rc3VzZXI6WXFCNH1tYVJvMQ=='
const btoaAuthCredentialsDev =
  'ZGV2LWZhY2UteW9nYS13c2hvb2tzdXNlcjptWUpTbWdtM3Vn'

export class EventsApi {
  private readonly api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  async sendEvent(
    event: Events,
    eventProperty: Record<string, any>,
    callback?: () => void,
  ): Promise<void> {
    const options = {
      method: RequestMethod.POST,
      headers: new Headers({
        Authorization: `Basic ${this.getBtoaAuthCredentials()}`,
      }),
      body: { event, ...eventProperty },
    }
    await this.api.makeRequest<never>('v1/events/landing', options)
    callback && callback()
  }

  private getBtoaAuthCredentials = (): string =>
    getCurrentEnv() === 'prod'
      ? btoaAuthCredentialsProd
      : btoaAuthCredentialsDev
}
